import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { DotLoader } from '@/components/ui/DotLoader'
import { useAdminAuthStore } from '../adminAuthStore'

/**
 * Route guard for everything under /admin except /admin/login.
 * 'unknown' = bootstrap still validating a stored token: show a spinner,
 * never flash the panel. 'anonymous' = bounce to login, remembering where
 * the visitor was headed so login can return them there.
 */
export function RequireAdmin() {
  const status = useAdminAuthStore((s) => s.status)
  const location = useLocation()

  if (status === 'unknown') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <DotLoader />
      </div>
    )
  }
  if (status === 'anonymous') {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
  }
  return <Outlet />
}
